/**
 * Count pill for a sidebar link. Lives on the blue Icewall field, so it is
 * solid danger-on-light rather than the usual light-on-blue treatment - the
 * point is that it catches the eye from across the menu.
 *
 * Renders nothing at zero; counts past 99 cap at "99+" so the pill cannot
 * push the label out of the link.
 */
export default function NavBadge({ count, label }: { count?: number; label: string }) {
  if (!count) return null
  return (
    <span
      aria-label={`${count} ${label}`}
      className="ml-auto min-w-6 rounded-full bg-status-danger px-1.5 py-0.5 text-center text-2xs font-semibold leading-4 text-background"
    >
      {count > 99 ? '99+' : count}
    </span>
  )
}
